import React from 'react';
import InvoiceMilestonesTable from './InvoiceMilestonesTable';
import OtherItemsTable from './OtherItemsTable';
import ProjectExpenses from './ProjectExpenses';
import RevenueRecognitionLedger from './RevenueRecognitionLedger';
import { HelpMessage } from '~/components';
import styled from 'styled-components';

const PreMessage = styled.div`
  white-space: pre-wrap;
  font-style: normal;
  word-break: break-word;
`;

export default function AccountingTab({
  project,
  formik,
  projectModel,
  onProjectExpensesChange,
  onInvoiceMilestonesChange,
  onOtherItemsChange,
  onRevenueRecognitionLedgerChange,
  onRefetch,
}) {
  return (
    <>
      {formik.values.accountingNotes && (
        <HelpMessage>
          <PreMessage>
            <strong>Accounting Notes:</strong>
            <br />
            {formik.values.accountingNotes}
          </PreMessage>
        </HelpMessage>
      )}

      {['fixed', 'fixed_recurring'].includes(projectModel.billingTypeId) && (
        <InvoiceMilestonesTable projectModel={projectModel} onChange={onInvoiceMilestonesChange} />
      )}

      {['fixed', 'fixed_recurring'].includes(projectModel.billingTypeId) &&
        ['manual', 'automated_hours', 'automated_tm_basis', 'automated_services_cost'].includes(
          projectModel.revenueRecognitionMethod,
        ) && (
          <RevenueRecognitionLedger
            project={project}
            formik={formik}
            projectModel={projectModel}
            onRefetch={onRefetch}
            onChange={onRevenueRecognitionLedgerChange}
          />
        )}

      {['tm', 'fixed', 'fixed_recurring'].includes(projectModel.billingTypeId) && (
        <OtherItemsTable projectModel={projectModel} onChange={onOtherItemsChange} />
      )}

      <ProjectExpenses projectModel={projectModel} onChange={onProjectExpensesChange} />
    </>
  );
}
